import {
  laptopMinXL,
  laptopMediumMax,
  tabletMin,
  mobileXXLargeMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';
import { Container as Button } from '../buttons/Button.style';
import { Text } from '../typography';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 30px 0;
  flex-direction: column;
  position: relative;

  @media (${laptopMinXL}), (${laptopMediumMax}) and (${tabletMin}) {
    flex-direction: row;
  }

  @media (${laptopMediumMax}) {
    margin: 30px auto;
    max-width: 460px;
  }
`;

export const Badge = styled.div`
  background: ${({ theme }) => theme.prime.GOLD};
  color: ${({ theme }) => theme.white};
  border-radius: 60px;
  width: 86px;
  height: 86px;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  padding: 10px 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(15deg);
  position: absolute;
  top: -10px;
  right: -10px;
  line-height: 1.1;
  font-family: ${platform.headingFont};

  b {
    display: block;
    font-size: 14px;
    color: ${({ theme }) => theme.prime.translucent.GOLD};
  }
`;

export const Item = styled.div`
  flex: 1;
`;

export const ItemContainer = styled.div<{ colour: string }>`
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-radius: 10px;
  background-color: ${({ colour }) => colour};
  border: 1px solid #dedede;
  flex-direction: column;

  ${Text} {
    color: ${({ theme }) => theme.textDark};
  }

  h3 {
    color: ${({ theme }) => theme.textDark};
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 8px;
    text-align: center;
    font-family: ${platform.headingFont};

    b {
      color: ${({ theme }) => theme.gold};
    }
  }
`;

export const ItemContent = styled.div`
  color: ${({ theme }) => theme.textDark};
  max-width: 250px;
  margin: 15px auto;

  @media (${mobileXXLargeMax}) {
    svg {
      display: none !important;
    }
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 10px;

  ${Button} {
    max-width: 400px;
  }
`;
